module.exports = __webpack_public_path__ + "static/civilized-to-death-fc20a258be0fe8bcc65d218b2f64f574.jpg";